// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.basic-modal {
  display: flex;
  flex-direction: column;
  width: 400px;
  min-height: 400px;
  margin: auto;
  background-color: #232323;
  padding: 10px;

  h2 {
    text-align: center;
  }

  .input-container {
    display: flex;
    flex-direction: row;

    label {
      margin-right: 5px;
    }
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
    margin-top: auto;
    justify-content: flex-end;

    button {
      margin-left: 8px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/misc/BasicModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,aAAa;;EAEb;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;;IAEnB;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;;IAEzB;MACE,gBAAgB;IAClB;EACF;AACF","sourcesContent":[".basic-modal {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  min-height: 400px;\n  margin: auto;\n  background-color: #232323;\n  padding: 10px;\n\n  h2 {\n    text-align: center;\n  }\n\n  .input-container {\n    display: flex;\n    flex-direction: row;\n\n    label {\n      margin-right: 5px;\n    }\n  }\n\n  .buttons-container {\n    display: flex;\n    flex-direction: row;\n    margin-top: auto;\n    justify-content: flex-end;\n\n    button {\n      margin-left: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
